import { useSuspense } from "@root/api/tools/axios";
import { useCallback } from "react";
import type { IGetUserResponse } from ".";
import { axiosInstance, axiosUser } from "./axios";

export const useGetUser = () => {
  const [state, execute, cancel] = axiosUser<IGetUserResponse, undefined, unknown>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: string) => {
      return execute({
        url: `${id}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useGetUserSuspense = (id: string) => {
  return useSuspense(
    () =>
      axiosInstance.get<IGetUserResponse>(`/${id}`, {
        withCredentials: true,
      }),
    [id]
  );
};
